ace.define(
  "ace/theme/echo",
  ["require", "exports", "module", "ace/lib/dom"],
  function(require, exports, module) {
    exports.isDark = true;
    exports.cssClass = "ace-echo";
    exports.cssText =
      "\
      ::-webkit-scrollbar {\
        background: none;\
        width: 16px;\
        height: 16px;\
     }\
     ::-webkit-scrollbar-thumb {\
         border: solid 0 rgba(0, 0, 0, 0);\
         border-right-width: 4px;\
         border-left-width: 4px;\
         -webkit-border-radius: 9px 4px;\
         -webkit-box-shadow: inset 0 0 0 1px rgba(128, 128, 128, 0.2), inset 0 0 0 4px rgba(128, 128, 128, 0.2);\
     }\
     ::-webkit-scrollbar-track-piece {\
         margin: 4px 0;\
     }\
     ::-webkit-scrollbar-thumb:horizontal {\
         border-right-width: 0;\
         border-left-width: 0;\
         border-top-width: 4px;\
         border-bottom-width: 4px;\
         -webkit-border-radius: 4px 9px;\
     }\
     ::-webkit-scrollbar-thumb:hover {\
         -webkit-box-shadow:\
           inset 0 0 0 1px rgba(128,128,128,0.9),\
           inset 0 0 0 4px rgba(128,128,128,0.9);\
     }\
     ::-webkit-scrollbar-corner {\
         background: transparent;\
     }\
     .ace_scrollbar-h{margin: 0 2px}\
.ace-echo .ace_gutter {\
background: #171717;\
color: rgb(144,145,148)\
}\
.ace-echo .ace_print-margin {\
width: 1px;\
background: none !important;\
background: #333333;\
border: none;\
}\
.ace-echo {\
background-color: #171717;\
color: #ffffff\
}\
.ace-echo .ace_cursor {\
color: #ffffff\
}\
.ace-echo .ace_marker-layer .ace_selection {\
background: #333333\
}\
.ace-echo.ace_multiselect .ace_selection.ace_start {\
box-shadow: 0 0 3px 0px #171717;\
border-radius: 2px\
}\
.ace-echo .ace_marker-layer .ace_step {\
background: rgba(168,39,250,0.25)\
}\
.ace-echo .ace_marker-layer .ace_bracket {\
margin: -1px 0 0 -1px;\
border: 1px solid #fa9557\
}\
.ace-echo .ace_marker-layer .ace_active-line {\
background: #333333\
}\
.ace-echo .ace_gutter-active-line {\
background-color: #333333\
}\
.ace-echo .ace_marker-layer .ace_selected-word {\
box-shadow: 0px 0px 0px 1px #fa9557;\
border-radius: 3px;\
}\
.ace-echo .ace_fold {\
background-color: #c36ff9;\
border-color: #ffffff\
}\
.ace-echo .ace_keyword {\
color: #c36ff9\
}\
.ace-echo .ace_punctuation {\
color: #e0e0e0\
}\
.ace-echo .ace_operator {\
color: #ffffff\
}\
.ace-echo .ace_constant.ace_language {\
color: #fa9557\
}\
.ace-echo .ace_constant.ace_numeric {\
color: #fa9557\
}\
.ace-echo .ace_constant.ace_character {\
color: #fa9557\
}\
.ace-echo .ace_constant.ace_character.ace_escape {\
color: #c36ff9\
}\
.ace-echo .ace_constant.ace_other {\
color: #fa9557\
}\
.ace-echo .ace_constant.ace_boolean {\
color: #fa9557\
}\
.ace-echo .ace_support.ace_function {\
color: #c36ff9\
}\
.ace-echo .ace_support.ace_constant {\
color: #fa9557\
}\
.ace-echo .ace_support.ace_class {\
font-style: italic;\
color: #d0b3ff\
}\
.ace-echo .ace_support.ace_type {\
font-style: italic;\
color: #d0b3ff\
}\
.ace-echo .ace_storage {\
color: #c36ff9\
}\
.ace-echo .ace_storage.ace_type {\
font-style: italic;\
color: #c36ff9\
}\
.ace-echo .ace_invalid {\
color: #171717;\
background-color: #fa9557\
}\
.ace-echo .ace_invalid.ace_deprecated {\
color: #171717;\
background-color: #c36ff9\
}\
.ace-echo .ace_string {\
color: #fa9557\
}\
.ace-echo .ace_string.ace_regexp {\
color: #fa9557\
}\
.ace-echo .ace_comment {\
color: #7a7a7a\
}\
.ace-echo .ace_variable {\
color: #ffffff\
}\
.ace-echo .ace_variable.ace_parameter {\
font-style: italic;\
color: #fa9557\
}\
.ace-echo .ace_entity.ace_other.ace_attribute-name {\
color: #c36ff9\
}\
.ace-echo .ace_entity.ace_name.ace_function {\
color: #c36ff9\
}\
.ace-echo .ace_entity.ace_name.ace_tag {\
color: #c36ff9\
}\
.ace-echo .ace_invisible {\
color: #4e4e4e;\
}\
.ace-echo .ace_indent-guide {\
background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAACCAYAAACZgbYnAAAAEklEQVQImWNgYGBgYHB3d/8PAAOIAdULw8qMAAAAAElFTkSuQmCC) right repeat-y\
}";
    exports.$selectionColorConflict = true;

    var dom = require("../lib/dom");
    dom.importCssString(exports.cssText, exports.cssClass, false);
  }
);
(function() {
  ace.require(["ace/theme/echo"], function(m) {
    if (typeof module == "object" && typeof exports == "object" && module) {
      module.exports = m;
    }
  });
})();
